/**
 * Licensed Materials - Property of IBM
 * (c) Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * Note to U.S. Government Users Restricted Rights:
 * Use, duplication or disclosure restricted by GSA ADP Schedule
 * Contract with IBM Corp.
 */
import React from 'react';
export var AppContext = /*#__PURE__*/React.createContext({
  account: null,
  // not in context.js
  cdnDomain: '',
  enableFSCloudDialog: false,
  envId: '',
  locale: '',
  readOnly: false,
  // not in context.js
  user: undefined
});